import React from 'react'
import './TxPlanAddPhaseRow.css'

interface TxPlanAddPhaseRowProps {
  onAddPhase: () => void
}

const TxPlanAddPhaseRow = ({
  onAddPhase,
}: TxPlanAddPhaseRowProps): React.ReactElement => {
  return (
    <button
      type="button"
      className="tx-plan-add-phase-row"
      onClick={onAddPhase}
      aria-label="Add phase to this plan"
    >
      <i className="ti ti-plus tx-plan-add-phase-icon" aria-hidden />
      <span>Add phase</span>
    </button>
  )
}

export default TxPlanAddPhaseRow
